import React from 'react';
import { createPortal } from 'react-dom';
import { useAppSelector } from '../../Store/store.ts';
import { SolutionSliderItemsSelector } from '../../Selectors/MatchingProductsSelectors';
import { IsProductPage } from '../../../FitAssistantShared/IsProductPage.js';
import ProductSlider from '../../../ProductSlider/ProductSlider.tsx';

const ProductSliderPortal = () => {
  const portal = document.querySelector('#REACT_productSlider_portal');
  const sliderItems = useAppSelector(SolutionSliderItemsSelector);
  const title = window._THULEDATA?.ProductDetail?.WhatIsIncludedText;

  if (!IsProductPage || !portal || sliderItems.length === 0) {
    return null;
  }

  return createPortal(
    <ProductSlider
      title={title}
      products={sliderItems}
      options={{
        showInfoButton: true,
        showBadges: false,
        analyticsProductListName: 'Fit assistant solution',
      }}
    />,
    portal
  );
};

export default ProductSliderPortal;
